import type { DialogContentNode } from "@/v2/framework/dialog/types";
import { getSupplementalsByEntity } from "@/services/supplementals";

type MarketTranslationRow = {
  name?: string | null;
  info?: string | null;
  eventMarketName?: string | null;
  supplementalNames?: {
    supplementalNameTypeId: string;
    name?: string | null;
    eventMarketName?: string | null;
  }[];
};

export const buildMarketTranslationFields = () => {
  const nodes: DialogContentNode[] = [
    {
      type: "text-field",
      name: "name",
      label: "table_columns.name",
      placeholder: "Enter name",
    },
    {
      type: "text-field",
      name: "eventMarketName",
      label: "table_columns.event_market_name",
      placeholder: "Enter event market name",
    },
    {
      type: "text-field",
      name: "info",
      label: "table_columns.info",
      placeholder: "Enter info",
    },
  ];

  for (const supplementalNameType of getSupplementalsByEntity("MARKET")) {
    nodes.push(
      {
        type: "text-field",
        name: `supplementalName_${supplementalNameType.id}_name`,
        label: `table_columns.${supplementalNameType.name.toLowerCase()}`,
        placeholder: "Enter name",
        valueFormatter: (row: unknown) => {
          const item = row as MarketTranslationRow;
          return (
            item.supplementalNames?.find(
              (entry) => String(entry.supplementalNameTypeId) === String(supplementalNameType.id),
            )?.name ?? ""
          );
        },
      },
      {
        type: "text-field",
        name: `supplementalName_${supplementalNameType.id}_eventMarketName`,
        label: `table_columns.${supplementalNameType.name.toLowerCase()}_event_market_name`,
        placeholder: "Enter event market name",
        valueFormatter: (row: unknown) => {
          const item = row as MarketTranslationRow;
          return (
            item.supplementalNames?.find(
              (entry) => String(entry.supplementalNameTypeId) === String(supplementalNameType.id),
            )?.eventMarketName ?? ""
          );
        },
      },
    );
  }

  return nodes;
};
